<div [class]="className" *ngIf="config; else pureTpl" (click)="load()">
  <ng-container *ngTemplateOutlet="pureTpl"></ng-container>
</div>
<ng-template #pureTpl><ng-content></ng-content></ng-template>
